import React, { Fragment, useEffect, useCallback, useContext, lazy, Suspense, useState } from 'react';
import { Route } from 'react-router-dom';
import 'bootstrap/js/dist/modal';
import axios from 'axios'
import errorHandler from '../../hoc/ErrorHandler';
import ModuleIsMounting from '../UI/ModuleIsMounting/ModuleIsMounting';
import AccessTokenAlert from '../UI/Modal/AccessTokenAlert/AccessTokenAlert';
import SetTimeZone from '../UI/SetTimeZome/SetTimeZone';
import LockScreen from '../UI/Modal/LockScreen/LockScreen';
import Settings from './Settings/Settings';
import Dashboard from './Dashboard/Dashboard';
import context from '../../context/auth-context';
// import Login from '../../containers/Auth/Login/Login';
import TransferWindow from './BackgroundTasks/TransferWindow';
import BackgroundTaskList from './BackgroundTasks/BackgroundTaskList';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { EBOARD_TABLE_THEME } from '../../constants';
import { ThemeProvider as MaterialProvider } from '@material-ui/core';
import { theme } from 'components/UI/Styles/Themes';

// =========================== | IMPORTS | ================================ //
const UserProfile = lazy(() => import('./UserProfile/UserProfile'));
const Groups = lazy(() => import('./Groups/Groups'));
const Evaluation = lazy(() => import('./Evaluation/Evaluation'));
const Budgets = lazy(() => import('./Budgets/Budgets'));
const Meetings = lazy(() => import('./Meetings/Meetings'));
const Compliance = lazy(() => import('./Compliance/Compliance'));
const Resources = lazy(() => import('./Resources/Resources'));
const Approvals = lazy(() => import('./Approvals/Approvals'));
const UserGroupAssociate = lazy(() => import('./Groups/Users/UserGroupAssociate'));
const Risks = lazy(() => import('./Risks'));


const Content = () => {
    const authContext = useContext(context);
    const [maximize, setMaximize] = useState(false);

    const handleMaximize = () => {
        setMaximize(!maximize)
    }
    useEffect(() => {
        if (window.location.hostname !== 'localhost') {
            window.addEventListener('beforeunload', event => {
                // Cancel the event
                event.preventDefault(); // Default behavior in Mozilla Firefox prompt will always be shown
                // Chrome requires returnValue to be set
                event.returnValue = '';
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    document.body.className = `app-notebook app-contacts page-aside-scroll page-aside-left`;

    const content = useCallback(() => {
        return (
            // authContext.authenticated ?
            <Fragment>
                <MaterialProvider theme={EBOARD_TABLE_THEME()}>
                    <AccessTokenAlert />
                    <LockScreen />
                    <SetTimeZone />
                    <Route path="/auth/profile" exact render={() => <Suspense fallback={<ModuleIsMounting module="Profile" />}><UserProfile /></Suspense>} />
                    <Route path="/dashboard" exact component={Dashboard} />
                    <Route path="/groups" render={() => <Suspense fallback={<ModuleIsMounting module="Groups/Users" />}><Groups /></Suspense>} />
                    <Route path="/evaluations" render={() => <Suspense fallback={<ModuleIsMounting module="Evaluation" />}><Evaluation /></Suspense>} />
                    <Route path="/budgets" render={() => <Suspense fallback={<ModuleIsMounting module="Budgets" />}><Budgets /></Suspense>} />
                    <Route path="/risks" render={() => <Suspense fallback={<ModuleIsMounting module="Risks" />}><Risks /></Suspense>} />
                    <Route path="/meetings" render={() => <Suspense fallback={<ModuleIsMounting module="Meetings" />}><Meetings /></Suspense>} />
                    <Route path="/approvals" render={() => <Suspense fallback={<ModuleIsMounting module="Approvals" />}><Approvals /></Suspense>} />
                    <Route path="/compliance" render={() => <Suspense fallback={<ModuleIsMounting module="Compliance" />}><Compliance /></Suspense>} />
                    <Route path="/resources" render={() => <Suspense fallback={<ModuleIsMounting module="Resources" />}><Resources /></Suspense>} />
                    <Route path="/usergroupassociate" render={() => <Suspense fallback={<ModuleIsMounting module="UserGroupAssociate" />}><UserGroupAssociate /></Suspense>} />
                    <Route path="/settings" component={Settings} />
                </MaterialProvider>
                <>
                    <CssBaseline />
                    <ThemeProvider theme={theme}>
                        <TransferWindow index={(0).toString()} handleMaximize={handleMaximize} maximize={maximize}>
                            <BackgroundTaskList />
                        </TransferWindow>
                    </ThemeProvider>
                </>

            </Fragment>
            // :
            // <Route path="/" component={Login} />
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authContext.authenticated])

    return content();
};

export default (errorHandler(Content, axios));